import createEnum from 'scripts/lib/create_enum';

export default createEnum(
  'ACCEPTED_OFFERED_CONCURRENT_SESSION',
  'ASSIGNED_CONVERSATION',
  'ASSIGNED_TASK',
  'DECLINED_OFFERED_CALL',
  'DECLINED_OFFERED_CONCURRENT_SESSION',
  'DECLINED_WARM_TRANSFER',
  'DUE_TASK',
  'INCOMING_CONCURRENT_MESSAGE',
  'INCOMING_CONCURRENT_SESSION',
  'OFFERED_CALL',
  'OFFERED_WARM_TRANSFER',
  'UNOFFERED_CALL',
  'UNOFFERED_WARM_TRANSFER',
  'UNREAD_CONVERSATION',
  'UNREAD_TASK'
);



// WEBPACK FOOTER //
// ./src/scripts/domain/models/routing_event/routing_event_type.js